export default __webpack_public_path__ + "static/media/ep5collage6.dc37019f.jpg";